/**
 * O'zbek tili (kirill)
 */

import type { Translations } from './uz';

export const uzCyrl: Translations = {
  common: {
    save: 'Сақлаш',
    cancel: 'Бекор қилиш',
    delete: 'Ўчириш',
    edit: 'Таҳрирлаш',
    add: 'Қўшиш',
    search: 'Қидириш',
    loading: 'Юкланмоқда...',
    empty: 'Маълумот топилмади',
    error: 'Хато',
    success: 'Муваффақият',
    confirmDelete: 'Ростдан ҳам ўчирилсинми?',
    yes: 'Ҳа',
    no: 'Йўқ',
    total: 'Жами',
    page: 'Саҳифа',
    previous: 'Олдинги',
    next: 'Кейинги',
    name: 'Номи',
    phone: 'Телефон',
    email: 'Email',
    status: 'Статус',
    actions: 'Амаллар',
    currency_uzs: 'сўм',
    close: 'Ёпиш',
  },

  nav: {
    dashboard: 'Бошқарув',
    kassa: 'Касса',
    orderRequests: 'Буюртмалар',
    specialOrders: 'Янги буюртмалар',
    products: 'Маҳсулотлар',
    categories: 'Категориялар',
    suppliers: 'Таминотчилар',
    customers: 'Мижозлар',
    debts: 'Қарзлар',
    debtCategories: 'Қарз категориялари',
    stats: 'Статистика',
    roles: 'Роллар ва ходимлар',
    users: 'Фойдаланувчилар',
    xodimlar: 'Ходимлар',
    stores: 'Дўконлар',
    marketplaceOrders: 'Маркетплейс',
    pickupPoints: 'Пикап пунктлари',
    promoCodes: 'Промокодлар',
    marketplaceBanners: 'Баннерлар',
    pickupOperator: 'Менинг пунктим',
    courier: 'Етказиб бериш',
    courierTracking: 'Курьерлар',
    settings: 'Созламалар',
    logout: 'Чиқиш',
  },

  auth: {
    login: 'Кириш',
    username: 'Логин',
    password: 'Парол',
    signIn: 'Кириш',
    welcome: 'Хуш келибсиз',
    loginSubtitle: 'AvtoFix POS тизимига киринг',
    invalidCredentials: 'Логин ёки парол нотўғри',
    loggingIn: 'Кирилмоқда...',
  },

  products: {
    title: 'Маҳсулотлар',
    new: 'Янги маҳсулот',
    searchPlaceholder: 'Ном, SKU ёки баркод бўйича қидириш...',
    statusAll: 'Ҳаммаси',
    statusAvailable: 'Мавжуд',
    statusPending: 'Кутилмоқда',
    statusFinished: 'Тугаган',
    empty: 'Маҳсулот топилмади',
    emptyHint: 'Биринчи маҳсулотингизни қўшинг',
    deleted: 'Маҳсулот ўчирилди',
  },

  customers: {
    title: 'Мижозлар',
    new: 'Янги мижоз',
    searchPlaceholder: 'Исм, телефон ёки email бўйича қидириш...',
    empty: 'Мижоз топилмади',
    orderCount: 'Буюртмалар',
    totalSpent: 'Жами',
    vip: 'VIP',
    created: 'Мижоз қўшилди',
    updated: 'Мижоз янгиланди',
    deleted: 'Мижоз ўчирилди',
  },

  debts: {
    title: 'Қарзлар',
    statusPending: 'Кутилмоқда',
    statusPaid: 'Тўланган',
    statusOverdue: 'Муддати ўтган',
    statusBlacklist: 'Қора рўйхат',
    amount: 'Қарз',
    paid: 'Тўланган',
    remaining: 'Қолдиқ',
    pay: 'Тўлов',
    payAmountPrompt: 'Тўлов миқдори (қолдиқ: {{remaining}} сўм):',
    invalidAmount: 'Нотўғри миқдор',
    paidFully: 'Қарз тўлиқ тўланди',
    paidPartial: 'Қисман тўлов қабул қилинди',
    blacklistConfirm: 'Мижозни қора рўйхатга олиш?',
    blacklisted: 'Қора рўйхатга олинди',
    empty: 'Қарз топилмади',
  },

  stats: {
    title: 'Статистика',
    subtitle: 'Даромад, топ маҳсулотлар, қарзлар — real-time',
    periodToday: 'Бугун',
    periodWeek: 'Охирги 7 кун',
    periodMonth: 'Охирги 30 кун',
    revenue: 'Даромад',
    profit: 'Фойда',
    orders: 'Буюртмалар',
    customers: 'Мижозлар',
    cash: 'Нақд',
    card: 'Карта',
    transfer: 'Ўтказма',
    topProducts: 'Топ сотилган маҳсулотлар',
    noSales: 'Сотув бўлмаган',
    debtsTitle: 'Қарзлар',
    totalDebt: 'Жами қарз',
    outstanding: 'Қолдиқ',
    lowStock: 'Сток кам',
    lowStockHint: '{{count}} та маҳсулот минимумдан паст',
  },

  users: {
    title: 'Ходимлар',
    new: 'Янги ходим',
    username: 'Логин',
    role: 'Роль',
    active: 'Фаол',
    empty: 'Ходим йўқ',
    blocked: 'Блокланди',
    activated: 'Фаоллаштирилди',
  },

  stores: {
    title: 'Дўконлар',
    new: 'Янги дўкон',
    mainStore: 'Асосий дўкон',
    setAsMain: 'Асосий дўкон қилиб белгилаш',
    address: 'Манзил',
    empty: 'Дўкон йўқ',
    usdRate: 'USD курс',
    markup: 'Markup',
    brand: 'Бренд',
  },

  offline: {
    online: 'Онлайн',
    offline: 'Оффлайн',
    syncing: 'Синхронланмоқда...',
    pending: 'Кутилаётган: {{count}}',
    dlq: 'Хато: {{count}}',
  },
};
